/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HandlerRoutingAnalysisResponse,
  ModelCloneQueryRequest,
  ModelCloneQueryResponse,
  ModelDeleteQueryResponse,
  ModelExecuteQueryByIdRequest,
  ModelGetQueryDetailResponse,
  ModelGetQueryRequest,
  ModelGetQueryResponse,
  ModelListQueryrunResponse,
  ModelStopQueryResponse,
  ModelSubmitQueryRequest,
  ModelTriggerQueryResponse,
  ModelUpdateQueryAccessRequest,
  ModelUpdateQueryAccessResponse,
  ModelUpdateQueryCacheRequest,
  ModelUpdateQueryCacheResponse,
  ModelUpdateQueryDisplayRequest,
  ModelUpdateQueryDisplayResponse,
  ModelUpdateQueryRequest,
  ModelUpdateQueryResponse,
  ModelUpdateQueryTextRequest,
  ModelUpdateQueryTextResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Queries<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get queries related table
   *
   * @tags query
   * @name QueriesCreate
   * @summary get queries related table
   * @request POST:/Queries
   */
  queriesCreate = (request: ModelGetQueryRequest, params: RequestParams = {}) =>
    this.request<ModelGetQueryResponse, any>({
      path: `/Queries`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description update query config,
   *
   * @tags example
   * @name QueriesCreate2
   * @summary update query config
   * @request POST:/queries/{id}
   * @originalName queriesCreate
   * @duplicate
   */
  queriesCreate2 = (
    id: string,
    request: ModelUpdateQueryRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelUpdateQueryResponse, any>({
      path: `/queries/${id}`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description delete query
   *
   * @tags example
   * @name QueriesDelete
   * @summary delete query
   * @request DELETE:/queries/{id}
   */
  queriesDelete = (id: string, params: RequestParams = {}) =>
    this.request<ModelDeleteQueryResponse, any>({
      path: `/queries/${id}`,
      method: 'DELETE',
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description update query access config
   *
   * @tags example
   * @name AccessCreate
   * @summary update query access config
   * @request POST:/queries/{id}/access
   */
  accessCreate = (
    id: string,
    request: ModelUpdateQueryAccessRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelUpdateQueryAccessResponse, any>({
      path: `/queries/${id}/access`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Get query routing decision and the reason for that decision.
   *
   * @tags ZettaDB API
   * @name AnalysisCreate
   * @summary Get query routing decision and the reason for that decision
   * @request POST:/queries/{id}/analysis
   */
  analysisCreate = (id: string, params: RequestParams = {}) =>
    this.request<HandlerRoutingAnalysisResponse, any>({
      path: `/queries/${id}/analysis`,
      method: 'POST',
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description update query cache config
   *
   * @tags example
   * @name CacheCreate
   * @summary update query cache config
   * @request POST:/queries/{id}/cache
   */
  cacheCreate = (
    id: string,
    request: ModelUpdateQueryCacheRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelUpdateQueryCacheResponse, any>({
      path: `/queries/${id}/cache`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description clone query
   *
   * @tags example
   * @name CloneCreate
   * @summary clone query
   * @request POST:/queries/{id}/clone
   */
  cloneCreate = (
    id: string,
    request: ModelCloneQueryRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCloneQueryResponse, any>({
      path: `/queries/${id}/clone`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description get query detail
   *
   * @tags example
   * @name DetailDetail
   * @summary get query detail
   * @request GET:/queries/{id}/detail
   */
  detailDetail = (id: string, params: RequestParams = {}) =>
    this.request<ModelGetQueryDetailResponse, any>({
      path: `/queries/${id}/detail`,
      method: 'GET',
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description update query display options
   *
   * @tags example
   * @name DisplayCreate
   * @summary update query display options
   * @request POST:/queries/{id}/display
   */
  displayCreate = (
    id: string,
    request: ModelUpdateQueryDisplayRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelUpdateQueryDisplayResponse, any>({
      path: `/queries/${id}/display`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description execute query by query id, returning result in response as a data stream. If the query takes long time, this endpoint will return HTTP 302 code with a queryrun id, e.g. {"queryrunId": "xxx"}. Then the client can poll status and get result using that queryrun id.
   *
   * @tags example
   * @name ExecuteCreate
   * @summary execute query by query id
   * @request POST:/queries/{id}/execute
   */
  executeCreate = (
    id: string,
    query: { includeColumnName: boolean; includeMetadata: boolean },
    request: ModelExecuteQueryByIdRequest,
    params: RequestParams = {}
  ) =>
    this.request<string, any>({
      path: `/queries/${id}/execute`,
      method: 'POST',
      query: query,
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description list queryruns for a given query
   *
   * @tags example
   * @name QueryrunsDetail
   * @summary list queryruns for a given query
   * @request GET:/queries/{id}/queryruns
   */
  queryrunsDetail = (id: string, params: RequestParams = {}) =>
    this.request<ModelListQueryrunResponse, any>({
      path: `/queries/${id}/queryruns`,
      method: 'GET',
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description execute query by query id, this is deprecated, please use /queries/{id}/execute
   *
   * @tags example
   * @name PostQueries
   * @summary execute query by query id, this is deprecated, please use /queries/{id}/execute
   * @request POST:/queries/{id}/run
   */
  postQueries = (
    id: string,
    query: { includeColumnName: boolean; includeMetadata: boolean },
    request: ModelExecuteQueryByIdRequest,
    params: RequestParams = {}
  ) =>
    this.request<string, any>({
      path: `/queries/${id}/run`,
      method: 'POST',
      query: query,
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description stop query by query id, returning a queryrun id, which could be checked for status
   *
   * @tags Data Lake APIs
   * @name StopCreate
   * @summary Stop query by id
   * @request POST:/queries/{id}/stop
   */
  stopCreate = (id: string, params: RequestParams = {}) =>
    this.request<ModelStopQueryResponse, any>({
      path: `/queries/${id}/stop`,
      method: 'POST',
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description update query text
   *
   * @tags example
   * @name TextCreate
   * @summary update query text
   * @request POST:/queries/{id}/text
   */
  textCreate = (
    id: string,
    request: ModelUpdateQueryTextRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelUpdateQueryTextResponse, any>({
      path: `/queries/${id}/text`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description trigger query by query id in async way, returning a queryrun id, which could be checked for status
   *
   * @tags Data Lake APIs
   * @name TriggerCreate
   * @summary Trigger query by id
   * @request POST:/queries/{id}/trigger
   */
  triggerCreate = (
    id: string,
    request: ModelSubmitQueryRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelTriggerQueryResponse, any>({
      path: `/queries/${id}/trigger`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
